

/**
 * @name InkImage
 * @description The InkImage service. Named InkImage to avoid a conflict over
 * 'Image' with the UI-Bootstrap Lightbox library
 * @param {type} $q Description
 * @param {type} $rootScope Description
 * @param {type} $http Description
 * @param {type} $timeout Description
 * @param {type} ENDPOINT Description
 * @param {type} Upload Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 * @return {type} Returns the service
 */
function InkImage(
  $q,
  $rootScope,
  $http,
  $timeout,
  ENDPOINT,
  Upload,
  AlertMessages,
  Session,
  _
) {
  InkImage.removeTempFile = removeTempFile;
  InkImage.deleteImage = deleteImage;
  InkImage.uploadFile = uploadFile;
  InkImage.get = get;
  InkImage.add = add;
  InkImage.update = update;
  InkImage.remove = remove;

  /**
   * @name get
   * @description Function to get an image
   * @param {number} id The id of the image to get
   * @return {object} Returns an object of strings representing the URLs of the
   * image
   */
  function get(id) {
    return $http.get(ENDPOINT.server + 'inkutils/api/v1.1/image/' + id + '/')
    .then(function(response) {
      return response.data;
    });
  }

  /**
   * @name add
   * @description Function to add an image
   * @param {file} file The file of the image to update
   * @return {object} Returns an object of strings representing the URLs of the
   * image
   */
  function add(file) {
    return $http.post(ENDPOINT.server +
    'inkutils/api/v1.1/image/', {file: file})
    .then(function(response) {
      return response.data;
    });
  }

  /**
   * @name update
   * @description Function to update an image
   * @param {number} id The id of the image to update
   * @param {unknown} file The file of the image to update
   * @return {object} Returns an object of strings representing the URLs of the
   * image
   */
  function update(id, file) {
    return $http.patch(ENDPOINT.server +
    'inkutils/api/v1.1/image/' + id + '/', {file: file})
    .then(function(response) {
      return response.data;
    });
  }

  /**
   * @name remove
   * @description Function to remove an image
   * @param {number} id The ID of the image to remove
   * @return {object} Returns an empty object to represent an image that's been
   * removed
   */
  function remove(id) {
    let file = '';
    return $http.patch(ENDPOINT.server +
    'inkutils/api/v1.1/image/' + id + '/', {file: file})
    .then(function(response) {
      return response.data;
    });
  }

  /**
   * @description Upload a File
   * @param {Unknown} files Unknown
   * @param {Unknown} errFiles Unknown
   * @param {array} uploadArray Unknown
   */
  function uploadFile(files, errFiles, uploadArray) {
    _.each(files, function(file) {
      uploadArray.push(file);
      file.progress = 0;
      file.upload = Upload.upload({url: ENDPOINT.server +
      'inkutils/api/v1.1/upload/ng-file-upload/', data: {file: file}})
      .then(function(response) {
        return response.data;
      }, function(error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
        uploadArray.splice(uploadArray.indexOf(file), 1);
        return;
      });

      file.upload.then(function(image) {
        $timeout(function() {
          file.result = image;
        });
      }, function(error) {
        // No error handling here.
      }, function(evt) {
        file.progress =
        Math.min(100, parseInt(100.0 * evt.loaded / evt.total, 10));
      });
    });
  }

/**
  * @description Remove a temp Image (when creating the project)
  * @param {Unknown} file Unknown
  * @param {array} uploadArray Unknown
  * @param {Unknown} index Unknown
  * @return {none} Returns API call
  */
  function removeTempFile(file, uploadArray, index) {
    return $http.post(ENDPOINT.server +
    'inkutils/api/v1.1/delete/tmpimage/', file)
    .then(function(response) {
      uploadArray.splice(index, 1);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

/**
  * @description Remove an Image from a Project
  * @param {Unknown} file Unknown
  * @return {none} Returns API call
  */
  function deleteImage(file) {
    if (!_.isUndefined(file.type)) {
      let url = ENDPOINT.server;
      if (file.type === 'reference') {
        url += 'projects/api/v1.1/referenceimage/' + file.id + '/';
      } else if (file.type === 'coverup') {
        url += 'projects/api/v1.1/coverupimage/' + file.id + '/';
      } else if (file.type === 'completed') {
        url += 'projects/api/v1.1/completedimage/' + file.id + '/';
      }
      let role = Session.activeState.role;
      url += '?role=' + role;
      if (Session.activeState.association) {
        let associationId = Session.activeState.association.id;
        url += '&association_id=' + associationId;
      }
      return $http.delete(url).then(function() {
      }, function(error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
      });
    }
    return $http.post(ENDPOINT.server +
    'inkutils/api/v1.1/delete/tmpimage/', file)
    .then(function() {
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return InkImage;
}

angular
  .module('inkfinder')
  .factory('InkImage', InkImage);



// WEBPACK FOOTER //
// ./components/image/image.service.js